module.exports = __webpack_public_path__ + "img/img_left_nav_recommend_hover.aa97ad58.svg";